<div class="col-12 mb-4">
    <h3 style="letter-spacing: .5px; font-weight: 500;" >
        <ng-content></ng-content>
    </h3>
</div>